import { useFieldConfig } from 'context/fields';
import isEmpty from 'lodash/isEmpty';
import policies from 'shared/configs/rbac/accessPolicies';
import { EntityType } from 'shared/constants/entityTypes';
import { ENABLED_MODULES } from 'shared/constants/fields';
import useAccessControl from './useAccessControl';
import usePermissionCheck from './usePermissionCheck';

export default function useSourceParameters() {
  const { getFields } = useFieldConfig();
  const sampleFieldConfigs = getFields({ entityType: EntityType.SAMPLE });
  const moduleEnabled = usePermissionCheck(ENABLED_MODULES.SOURCES);
  const hasReadPermission = useAccessControl(policies.route.sources);
  const hasCreatePermission = useAccessControl(
    policies.ui.sourceDropdownCreateBtn
  );

  const sourceFieldConfig = (sampleFieldConfigs || []).find(
    (f) => f.name.toUpperCase() === EntityType.SOURCE
  );
  const fieldShown = {
    globally: !isEmpty(sourceFieldConfig),
    onOrderRequest:
      !isEmpty(sourceFieldConfig) && sourceFieldConfig.orderRequestField,
  };
  const isEnabled = moduleEnabled && fieldShown.globally && hasReadPermission;
  const canCreate =
    moduleEnabled && hasCreatePermission && fieldShown.onOrderRequest;

  return { canCreate, isEnabled };
}
